import { createContext, useContext, useEffect, useState } from 'react';
import useInterval from '../../hooks/useInterval';
import bureaucrat from '../../util/Bureaucrat';

/**
 * Based on: https://usehooks.com/useAuth/
 */
export const TeamsGwPromptsContext = createContext();

export const useTeamsGwPrompts = () => useContext(TeamsGwPromptsContext);

export const useTeamsGwPromptsUpdate = (getPromptsInfo) => {
  const [updatePromptsInfo, setUpdatePromptsInfo] = useState(null);
  const [promptChanges, setPromptChanges] = useState({});

  useEffect(() => {
    if (updatePromptsInfo?.task?.isComplete) {
      (async () => {
        setPromptChanges({});
        await getPromptsInfo();
        setUpdatePromptsInfo(null);
      })();
    }
  }, [
    getPromptsInfo,
    setUpdatePromptsInfo,
    updatePromptsInfo?.task?.isComplete,
  ]);

  useInterval(
    () => {
      (async () => {
        const task = await bureaucrat.getTask(updatePromptsInfo.task.taskId);
        setUpdatePromptsInfo((previous) => ({ ...previous, task }));
        if (task.errorMsg) {
          updatePromptsInfo.parseErrorMessage(task.errorMsg);
        }
      })();
    },
    updatePromptsInfo && !updatePromptsInfo.task.isComplete ? 1000 : null,
  );

  return {
    promptChanges,
    setPromptChanges,
    updatePromptsInfo,
    setUpdatePromptsInfo,
  };
};
